import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import reconcileWin32MailRibbonConfiguration from '../util/reconcileWin32MailRibbonConfiguration';

const applyWin32StyleToMailRibbonConfigurationMutator: (isWin32StylingEnabled: boolean) => void =
    mutatorAction(
        'applyWin32StyleToMailRibbonConfiguration',
        (isWin32StylingEnabled: boolean): void => {
            for (const ribbonStore of getStore().entries.values()) {
                reconcileWin32MailRibbonConfiguration(
                    ribbonStore.ribbonConfig,
                    isWin32StylingEnabled
                );
            }
        }
    );

export default applyWin32StyleToMailRibbonConfigurationMutator;
